module.exports = __webpack_public_path__ + "static/media/card_m3b.52f462b5.jpg";